// import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/Locale.js";
//service
import AccountHelper from "@/helper/AccountHelper";

export default {
    inject: ["AccountStore"],
    data: function () {
        return {
            lbl: Locale.getLbl(),
            localeCode: Locale.getLocaleCode(),
            localShort: Locale.getLocaleShort()
        };
    },
    methods: {
        switchLang: function (locale) {
            if (this.localeCode == locale) {
                return;
            }

            if (this.AccountStore.state.isLogin) {
                AccountHelper.apiUpdateProfileLocale(locale).then(() => {

                    Locale.setLocale(locale);
                    this.lbl = Locale.getLbl();
                    this.localeCode = locale;

                    window.location.reload();
                }).catch((err) => {
                    console.log(err)
                    // this.errorApi(err);
                })
            } else {
                console.log('not login');
                // window.location.reload();
            }
        }
    },
};
